module.exports = __webpack_public_path__ + "32b7c3088703bf86c95e8b86af2a8f03.svg";